import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./pages/Home"
import WebDev from "./pages/WebDev"
import MobileDev from "./pages/MobileDev"
import ECommerce from "./pages/ECommerce"
import Seo from "./pages/Seo"
import Erp from "./pages/Erp"
import Digital from "./pages/DevDigital"
import Processus from "./pages/Processus"
import Politique from "./pages/Politique"
import Mention from "./pages/MentionLegales"
import NotFound from "./pages/NotFound";
import Team from "./pages/Team";

import ReactGA from 'react-ga';
const TRACKING_ID = "G-PRLDXVEKGC"; // YOUR_OWN_TRACKING_ID
ReactGA.initialize(TRACKING_ID);

function App() {
  return (
    <BrowserRouter >
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route exact path="services/developpementWeb" element={<WebDev />} />
        <Route exact path="services/developpementMobile" element={<MobileDev />} />
        <Route exact path="services/e_commerce" element={<ECommerce />} />
        <Route exact path="services/seo" element={<Seo />} />
        <Route exact path="services/erp" element={<Erp />} />
        <Route exact path="services/transformation_digital" element={<Digital />} />
        <Route exact path="processus" element={<Processus />} />
        <Route exact path="politique_de_confidentialite" element={<Politique />} />
        <Route exact path="mentions_legales" element={<Mention />} />
        <Route exact path="equipe" element={<Team />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
